import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "@/data/siteData";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Logo compact />

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`text-sm font-semibold transition-colors hover:text-[#FF5A00] ${
                  pathname === n.to ? "text-[#FF5A00]" : "text-gray-700"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/kontakt"
              data-testid="header-cta-btn"
              className="hidden sm:inline-flex items-center bg-[#FF5A00] text-white font-semibold text-sm px-5 py-2.5 rounded-sm hover:bg-[#E04F00] transition-colors"
            >
              Indhent tilbud
            </Link>
            <button
              data-testid="mobile-menu-toggle"
              className="lg:hidden p-2 text-gray-900"
              onClick={() => setOpen(!open)}
              aria-label="Menu"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-200 bg-white" data-testid="mobile-menu">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="py-3 px-2 text-base font-semibold text-gray-800 hover:text-[#FF5A00] border-b border-gray-100"
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/kontakt"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-btn"
              className="mt-3 text-center bg-[#FF5A00] text-white font-semibold px-5 py-3 rounded-sm"
            >
              Indhent tilbud
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
